export var TooltipCssClass;
(function (TooltipCssClass) {
    TooltipCssClass["Base"] = "iress-tooltip";
    TooltipCssClass["Activator"] = "iress-tooltip__activator";
    TooltipCssClass["Content"] = "iress-tooltip__content";
})(TooltipCssClass || (TooltipCssClass = {}));
export var TooltipManagementTask;
(function (TooltipManagementTask) {
    TooltipManagementTask[TooltipManagementTask["Add"] = 0] = "Add";
    TooltipManagementTask[TooltipManagementTask["Remove"] = 1] = "Remove";
})(TooltipManagementTask || (TooltipManagementTask = {}));
//# sourceMappingURL=tooltip.types.js.map